import { render, staticRenderFns } from "./recent.vue?vue&type=template&id=3302727e&scoped=true&"
import script from "./recent.vue?vue&type=script&lang=js&"
export * from "./recent.vue?vue&type=script&lang=js&"
import style0 from "./recent.vue?vue&type=style&index=0&id=3302727e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3302727e",
  null
  
)

export default component.exports